"use client";

import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";


export default function EditModal({
    loading,
  isOpen,
  onClose,
  onSave,
  title = "ویرایش",
  children,
  maxWidth = "max-w-2xl",
  maxHeight = "max-h-[80vh]",
}) {

  useEffect(() => {
    let el = document.getElementById("modal-root");
    if (!el) {
      el = document.createElement("div");
      el.id = "modal-root";
      document.body.appendChild(el);
    }
  }, []);


  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose && onClose();
    };
    if (isOpen) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  if (typeof document === "undefined") return null;

  return createPortal(
    <AnimatePresence>
      {isOpen && (

        <motion.div
          key="overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.18 }}
          className="fixed inset-0   z-50 px-5 flex items-center justify-center"
          aria-modal="true"
          role="dialog"
        >

          <div
            onClick={onClose}
            className="absolute inset-0 bg-black/55 backdrop-blur-sm"
            aria-hidden="true"
          />

     
          <motion.div
            key="modal"
            initial={{ opacity: 0, y: 24, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.98 }}
            transition={{ duration: 0.28, ease: "easeOut" }}
            onClick={(e) => e.stopPropagation()}

            className={`relative  h-max py-10 z-40 w-full lg:max-w-5xl ms:max-w-4xl ${maxWidth} ${maxHeight} bg-white rounded-3xl shadow-xl
                       p-4 md:p-4 overflow-y-auto flex flex-col`}
            style={{

              boxShadow:
                "0 10px 30px rgba(2,6,23,0.15), inset 0 1px 0 rgba(255,255,255,0.35)",
            }}
          >
 
            <div className="flex items-start justify-between gap-3">
              <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            </div>


            <div className="flex-1 overflow-y-auto p-6">
              <div className="relative overflow-visible">
                {children}
              </div>
            </div>
    
            <div className="mt-auto lg:text-[16px] text-[12px] pt-3 border-t border-gray-100 -mx-4 px-4 md:px-6 bg-gradient-to-t from-white/60 to-transparent">
              <div className="flex items-center justify-end gap-3">
                <button
                  onClick={onClose}
                  className=" lg:py-0 h-10 py-2 px-4 rounded-md bg-white border border-gray-300 text-gray-400  font-medium hover:bg-gray-50 transition"
                >
                  لغو تغییرات
                </button>

                <button
                  onClick={onSave}
                  className="lg:py-0 h-10 py-2 px-4 rounded-md bg-special border border-special text-white  font-medium hover:opacity-95 transition"
                >
                    {
                        loading?
                        "منتظر بمانید ..."
                        :
                       "ذخیره تغییرات"


                    }
              
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.getElementById("modal-root") || document.body
  );
}
